export default __webpack_public_path__ + "static/media/2.b68c9271.png";